import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=36eda8ce&lang=pug&"
import script from "./complete.ts?vue&type=script&lang=ts&"
export * from "./complete.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports